
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card, CardContent } from "@/components/ui/card";

interface Quote {
  fr: {
    text: string;
    author: string;
    title?: string;
  };
  en: {
    text: string;
    author: string;
    title?: string;
  };
}

export const PressQuotesSection = () => {
  const { language } = useLanguage();
  
  const quotes: Quote[] = [
    {
      fr: {
        text: "Je trouve ça bien cette reconnaissance du travail fourni [...] On est hyper libre et c'est ce qui était le plus important pour moi.",
        author: "@Beltaviaepp",
        title: "membre de la Creator Academy"
      },
      en: {
        text: "I appreciate this recognition of the work done [...] We are extremely free and that's what was most important to me.",
        author: "@Beltaviaepp",
        title: "member of the Creator Academy"
      }
    },
    {
      fr: {
        text: "Ce que le streaming a été pour l'écoute, Recut veut l'être pour le remix.",
        author: "Tangui Friant",
        title: "DG de Recut"
      },
      en: {
        text: "What streaming has been for listening, Recut wants to be for remixing.",
        author: "Tangui Friant",
        title: "CEO of Recut"
      }
    }
    // StudioCanal quote removed
  ];
  
  return (
    <section className="py-12 px-4 bg-muted/30">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-2xl md:text-3xl font-bold mb-8">
          🗣️ {language === 'fr' ? 'À citer librement' : 'Free to quote'}
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {quotes.map((quote, index) => {
            const { text, author, title } = language === 'fr' ? quote.fr : quote.en;
            
            return (
              <Card 
                key={index} 
                className="border-border/40 bg-card/80 backdrop-blur-sm hover:shadow-md transition-all duration-300"
              >
                <CardContent className="p-6">
                  <p className="text-lg italic mb-4 relative">
                    <span className="text-3xl text-primary/20 absolute -left-2 -top-2">"</span>
                    {text}
                    <span className="text-3xl text-primary/20 absolute -bottom-5 right-0">"</span>
                  </p>
                  <div className="flex items-center mt-6">
                    <div>
                      <p className="font-medium">
                        {author}
                      </p>
                      {title && (
                        <p className="text-sm text-muted-foreground">
                          {title}
                        </p>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
